(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const C = window.CYLA || { routes: { cart_add: '/cart/add', cart: '/cart', cart_change: '/cart/change' }, moneyFormat: '${{amount}}' };

  const money = (cents) => {
    const amount = (cents / 100).toFixed(2);
    const clean = amount.endsWith('.00') ? amount.slice(0, -3) : amount;
    const fmt = C.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return amount.replace('.', ',');
      return Number(clean).toLocaleString('en-US', { minimumFractionDigits: clean.includes('.') ? 2 : 0 });
    });
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Mobile menu & search */
  const menu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { menu.hidden = false; document.body.style.overflow = 'hidden'; }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { menu.hidden = true; document.body.style.overflow = ''; }));
  const search = $('[data-search-panel]');
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => { search.hidden = !search.hidden; if (!search.hidden) $('input[type=search]', search).focus(); }));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => { search.hidden = true; }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { if (search) search.hidden = true; closeDrawer(); if (menu) { menu.hidden = true; document.body.style.overflow = ''; } } });

  /* Announcement rotation */
  $$('[data-announcement]').forEach((bar) => {
    const msgs = $$('.announcement__msg', bar); if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0; const ms = (+bar.dataset.speed || 5) * 1000;
    setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, ms);
  });

  /* Sticky add-to-bag (mobile) */
  $$('[data-sticky-atc]').forEach((bar) => {
    const target = $('[data-add]');
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([e]) => { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(target);
    $('button', bar).addEventListener('click', () => { const f = $('#product-form'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); });
  });

  /* Hero video */
  $$('[data-video-toggle]').forEach((b) => b.addEventListener('click', () => {
    const v = b.closest('.hero').querySelector('video');
    if (!v) return;
    if (v.paused) { v.play(); b.textContent = '❚❚'; b.setAttribute('aria-label', 'Pause video'); } else { v.pause(); b.textContent = '►'; b.setAttribute('aria-label', 'Play video'); }
  }));

  /* Sliders */
  $$('[data-slider]').forEach((s) => {
    const track = $('[data-slider-track]', s), prev = $('[data-slider-prev]', s), next = $('[data-slider-next]', s);
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 24 : 300);
    const update = () => { prev.disabled = track.scrollLeft < 5; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5; };
    prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true }); update();
  });

  /* Collection filters & sort: submit on change */
  $$('[data-filters]').forEach((f) => {
    f.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(f));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.search = params.toString();
    });
    document.addEventListener('click', (e) => { $$('.filter[open]', f).forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); }); });
  });

  /* Cart drawer */
  const drawer = $('[data-cart-drawer]');
  const countEls = $$('[data-cart-count]');
  function closeDrawer() { if (drawer) { drawer.hidden = true; document.body.style.overflow = ''; } }
  async function renderCart(open) {
    const cart = await fetch(`${C.routes.cart}.js`).then((r) => r.json());
    countEls.forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!drawer) return;
    const body = $('[data-cart-body]', drawer);
    body.innerHTML = cart.items.length ? `<ul class="cart-lines">${cart.items.map((it, i) => `
      <li class="cart-line">
        <a class="cart-line__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'))}" alt="">` : ''}</a>
        <div class="cart-line__info">
          <a class="cart-line__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.variant_title ? `<p class="muted">${esc(it.variant_title)}</p>` : ''}
          <div class="cart-line__qty"><input type="number" min="0" value="${it.quantity}" data-line="${i + 1}" aria-label="Quantity"><button class="link-underline" type="button" data-remove="${i + 1}">Remove</button></div>
        </div>
        <p class="cart-line__total">${money(it.final_line_price)}</p>
      </li>`).join('')}</ul>` : '<p class="empty">Your bag is empty.</p>';
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    $$('[data-ship-bar]').forEach((bar) => {
      const t = +bar.dataset.threshold; if (!t) return;
      const left = t - cart.total_price;
      $('[data-ship-fill]', bar).style.width = Math.min(100, (cart.total_price / t) * 100) + '%';
      $('[data-ship-msg]', bar).innerHTML = left > 0 ? `You're <strong>${money(left)}</strong> away from free US shipping` : `You've unlocked <strong>free US shipping</strong>`;
      bar.classList.toggle('is-done', left <= 0);
    });
    if (open) { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  async function changeLine(line, quantity) {
    await fetch(`${C.routes.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart(false);
  }
  if (drawer) {
    $$('[data-cart-close]', drawer).forEach((b) => b.addEventListener('click', closeDrawer));
    drawer.addEventListener('change', (e) => { if (e.target.dataset.line) changeLine(+e.target.dataset.line, +e.target.value); });
    drawer.addEventListener('click', (e) => { if (e.target.dataset.remove) changeLine(+e.target.dataset.remove, 0); });
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => { if (document.body.classList.contains('template-cart')) return; e.preventDefault(); renderCart(true); }));
  }
  async function addItems(items) {
    const res = await fetch(`${C.routes.cart_add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
    await renderCart(true);
    return data;
  }

  /* Buy the set */
  $$('[data-buy-set]').forEach((f) => f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = $('button', f); btn.disabled = true;
    try { await addItems($$('input[name=variant]', f).map((i) => ({ id: +i.value, quantity: 1 }))); } catch (err) { alert(err.message); }
    btn.disabled = false;
  }));

  /* Product page */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('#product-form', root) || $('form[action*="/cart/add"]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root);
    const errEl = $('[data-error]', root);
    /* Gallery: fade on desktop, scroll-snap swipe on mobile, lightbox zoom everywhere */
    const main = $('.product__main', root);
    const slides = $$('.product__slide', root);
    const counter = $('[data-counter]', root);
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
    let activeIdx = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    const markActive = (idx) => {
      activeIdx = idx;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      const id = slides[idx] && slides[idx].dataset.mediaId;
      $$('[data-thumb]', root).forEach((t) => {
        const on = String(t.dataset.thumb) === String(id);
        t.classList.toggle('is-active', on);
        if (on && isMobile()) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      if (counter) counter.textContent = `${idx + 1} / ${slides.length}`;
    };
    const showMedia = (id, smooth = true) => {
      const idx = slides.findIndex((s) => String(s.dataset.mediaId) === String(id));
      if (idx < 0) return;
      markActive(idx);
      if (isMobile() && main) main.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    if (main && slides.length > 1) {
      let raf;
      main.addEventListener('scroll', () => {
        if (!isMobile()) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const idx = Math.round(main.scrollLeft / main.clientWidth);
          if (idx !== activeIdx && slides[idx]) markActive(idx);
        });
      }, { passive: true });
      window.addEventListener('resize', () => { if (isMobile()) main.scrollTo({ left: slides[activeIdx].offsetLeft }); });
    }
    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
    if (slides.length) { markActive(activeIdx); if (isMobile() && main) requestAnimationFrame(() => main.scrollTo({ left: slides[activeIdx].offsetLeft })); }

    /* Lightbox */
    const lb = $('[data-lightbox]', root);
    if (lb && slides.length) {
      const stage = $('[data-lightbox-stage]', lb), img = $('[data-lightbox-img]', lb), lbCounter = $('[data-lightbox-counter]', lb);
      let lbIdx = 0, scale = 1, tx = 0, ty = 0, lastFocus = null;
      const pointers = new Map(); let pinchStart = null, dragStart = null, moved = false;
      const apply = () => { img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`; stage.classList.toggle('is-zoomed', scale > 1); };
      const clamp = () => {
        const r = img.getBoundingClientRect(), s = stage.getBoundingClientRect();
        const w = img.offsetWidth * scale, h = img.offsetHeight * scale;
        const baseX = img.offsetLeft, baseY = img.offsetTop;
        const minX = Math.min(0, s.width - w) - baseX, maxX = Math.max(0, s.width - w) - baseX;
        const minY = Math.min(0, s.height - h) - baseY, maxY = Math.max(0, s.height - h) - baseY;
        tx = Math.min(maxX, Math.max(minX, tx)); ty = Math.min(maxY, Math.max(minY, ty));
      };
      const reset = () => { scale = 1; tx = 0; ty = 0; apply(); };
      const load = (idx) => {
        lbIdx = (idx + slides.length) % slides.length;
        img.src = slides[lbIdx].dataset.zoom || $('img', slides[lbIdx]).currentSrc;
        img.alt = ($('img', slides[lbIdx]) || {}).alt || '';
        lbCounter.textContent = slides.length > 1 ? `${lbIdx + 1} / ${slides.length}` : '';
        reset();
      };
      const open = (idx) => { lastFocus = document.activeElement; load(idx); lb.hidden = false; document.body.classList.add('lightbox-open'); $('[data-lightbox-close]', lb).focus(); };
      const close = () => { lb.hidden = true; document.body.classList.remove('lightbox-open'); showMedia(slides[lbIdx].dataset.mediaId, false); if (lastFocus) lastFocus.focus(); };
      const zoomAt = (cx, cy, target) => {
        const r = img.getBoundingClientRect();
        const px = (cx - r.left) / scale, py = (cy - r.top) / scale; // image-space point
        const prev = scale; scale = target;
        tx += px * prev - px * scale; ty += py * prev - py * scale;
        clamp(); apply();
      };
      $$('.product__slide', root).forEach((s, i) => s.addEventListener('click', () => open(i)));
      $('[data-zoom-open]', root).addEventListener('click', () => open(activeIdx));
      $('[data-lightbox-close]', lb).addEventListener('click', close);
      $('[data-lightbox-prev]', lb).addEventListener('click', () => load(lbIdx - 1));
      $('[data-lightbox-next]', lb).addEventListener('click', () => load(lbIdx + 1));
      document.addEventListener('keydown', (e) => {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') load(lbIdx - 1);
        if (e.key === 'ArrowRight') load(lbIdx + 1);
      });
      stage.addEventListener('pointerdown', (e) => {
        stage.setPointerCapture(e.pointerId);
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        moved = false;
        if (pointers.size === 2) {
          const [a, b] = [...pointers.values()];
          pinchStart = { d: Math.hypot(a.x - b.x, a.y - b.y), scale, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 };
          dragStart = null;
        } else if (pointers.size === 1) {
          dragStart = { x: e.clientX, y: e.clientY, tx, ty, t: Date.now() };
          if (scale > 1) stage.classList.add('is-dragging');
        }
      });
      stage.addEventListener('pointermove', (e) => {
        if (!pointers.has(e.pointerId)) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pointers.size === 2 && pinchStart) {
          const [a, b] = [...pointers.values()];
          const d = Math.hypot(a.x - b.x, a.y - b.y);
          const target = Math.min(4, Math.max(1, pinchStart.scale * (d / pinchStart.d)));
          zoomAt(pinchStart.cx, pinchStart.cy, target);
          moved = true;
        } else if (pointers.size === 1 && dragStart) {
          const dx = e.clientX - dragStart.x, dy = e.clientY - dragStart.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
          if (scale > 1) { tx = dragStart.tx + dx; ty = dragStart.ty + dy; clamp(); apply(); }
          else { img.style.transform = `translate(${dx * 0.9}px, 0)`; }
        }
      });
      const up = (e) => {
        if (!pointers.has(e.pointerId)) return;
        pointers.delete(e.pointerId);
        stage.classList.remove('is-dragging');
        if (pointers.size < 2) pinchStart = null;
        if (pointers.size === 0 && dragStart) {
          const dx = e.clientX - dragStart.x, dy = e.clientY - dragStart.y;
          if (scale === 1) {
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { load(lbIdx + (dx < 0 ? 1 : -1)); }
            else if (!moved) { zoomAt(e.clientX, e.clientY, 2.5); }
            else apply();
          } else if (!moved) { reset(); }
          dragStart = null;
        }
      };
      stage.addEventListener('pointerup', up); stage.addEventListener('pointercancel', up);
      stage.addEventListener('wheel', (e) => { if (lb.hidden) return; e.preventDefault(); zoomAt(e.clientX, e.clientY, Math.min(4, Math.max(1, scale * (e.deltaY < 0 ? 1.15 : 0.87)))); }, { passive: false });
      stage.addEventListener('dblclick', (e) => { e.preventDefault(); });
    }

    const update = () => {
      const selected = $$('[data-option]:checked', root).map((i) => i.value);
      const v = product.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      $$('[data-option-label]', root).forEach((el, i) => { el.textContent = selected[i] || ''; });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      $$('[data-sticky-price]').forEach((el) => { el.textContent = money(v.price); });
      $$('[data-sticky-atc] button').forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? 'Add to bag' : 'Sold out'; });
      $('[data-price]', root).innerHTML = `<span class="price">${money(v.price)}</span>${v.compare_at_price > v.price ? `<s class="price price--was">${money(v.compare_at_price)}</s>` : ''}`;
      const sku = $('[data-sku]', root); if (sku) sku.textContent = v.sku || '';
      if (v.featured_media) showMedia(v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('[data-option]', root).forEach((i) => i.addEventListener('change', update));

    const qty = $('[data-qty]', root);
    if (qty) {
      const input = $('input', qty);
      $('[data-qty-minus]', qty).addEventListener('click', () => { input.value = Math.max(1, +input.value - 1); });
      $('[data-qty-plus]', qty).addEventListener('click', () => { input.value = +input.value + 1; });
    }
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errEl.hidden = true; const label = addBtn.textContent; addBtn.disabled = true; addBtn.textContent = 'Adding…';
      try { await addItems([{ id: +idInput.value, quantity: +(form.querySelector('[name=quantity]') || { value: 1 }).value }]); }
      catch (err) { errEl.textContent = err.message; errEl.hidden = false; }
      addBtn.disabled = false; addBtn.textContent = label;
    });
  });

  /* Recommendations */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const inner = tmp.querySelector('.shopify-section');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (_) { /* ignore */ }
  });
})();
